import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Media from "react-media";
class SubNavigationItemAvailability extends Component {
  render() {
    const submenu = [
      {
        id: 0,
        title: "Item Availability",
        link: "",
      },
      {
        id: 1,
        title: "Category",
        link: "",
      },
    ];
    return (
      <div className="container-fluid p-0 mb-3">
        <div
          // style={{
          //   margin: "2% 0% 2% 0%",
          // }}
          className="d-flex "
        >
          <div
            align="center"
            className="super-admin-sub-navigation-menu-orders"
          >
            <span
              style={{
                color: "#EE3A23",
                borderBottom: "1px solid #EE3A23",
                padding: "5px",
                fontWeight: "bold",
                cursor: "pointer",
              }}
            >
              Item Availability
            </span>{" "}
            &nbsp;&nbsp;{" "}
            {/* <Media query="(min-width: 992px)">
              <span
                style={{ color: "#9E9E9E", cursor: "pointer" }}
                onClick={() => {
                  this.props.history.push("/categorydashboard");
                }}
              >
                Category
              </span>
            </Media> */}
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(SubNavigationItemAvailability);

// export default SubNavigationItemAvailability;
